'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './list.routes';

export class PiperListComponent {

  constructor(Auth, PiperListService, dialogs, $stateParams) {
    'ngInject';

    this.PiperListService = PiperListService;
    this.dialogs = dialogs;
    this.Auth = Auth;

    this.type = $stateParams.type;

    this.guests = [];

    this.PiperListService.getByHostAndType({
      hostid: Auth.getCurrentUserSync()._id,
      type: this.type
    }, (data) => {
      this.guests = data;
    });
  }

  delete(guestList) {
    var that = this;

    var guestText = (guestList.guest.isBusiness) ? guestList.guest.business : guestList.guest.firstName + ' ' + guestList.guest.lastName;

    var dlg = this.dialogs.confirm("Delete Guest from List?", "Do you really want to delete the guest from this list?" +
      "<br/><br/><b>" + guestText + "</b>");
    dlg.result.then(() => {
      that.PiperListService.delete({id: guestList._id},
        () => {
          that.guests = that.guests.filter(function( obj ) {
            return obj._id !== guestList._id;
          });
        },
        err => {
          alert("Could not delete guest from list");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.piperList', [uiRouter])
  .config(routes)
  .component('piperList', {
    template: require('./list.html'),
    controller: PiperListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/piper/list/show/list.component.js